import React from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { RootState } from 'redux/rootReducer';
import { userLoggingOut } from 'redux/loginSlice';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@lifesize/clients.mui-components';
import { LsKey, lsSet } from 'utils/localStorageUtils';

const Footer = () => {
  const dispatch = useDispatch();
  const displayName = useSelector((state: RootState) => state.checkIn.session.displayName);
  const classes = useStyles();

  const handleSignOut = () => {
    lsSet(LsKey.A_TOKEN, '');
    lsSet(LsKey.Settings, '');
    lsSet(LsKey.DefaultQuickInvite, '');
    lsSet(LsKey.Appointment, '');
    dispatch(userLoggingOut());
  };

  return (
    <Box className={classes.footer}>
      {displayName && (
        <Typography data-testid="signedInTitle" variant="subtitle1">
          {intl.getHTML('signedInAs', { name: displayName })}
        </Typography>
      )}
      <Link
        data-testid="signOutLink"
        component="button"
        variant="body1"
        onClick={handleSignOut}
        className={classes.logout}
        underline="none"
      >
        {intl.get('signOut')}
      </Link>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 100,
    '& h6': {
      textAlign: 'center',
      wordBreak: 'break-word',
      // IE media queries
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        wordBreak: 'break-all'
      },
      // Legacy Edge queries Edge 12 -15
      '@supports (-ms-accelerator:true)': {
        wordBreak: 'break-all'
      },
      // Legacy Edge 16+
      '@supports (-ms-ime-align:auto)': {
        wordBreak: 'break-all'
      }
    }
  },
  logout: {
    color: colors.lifesize,
    display: 'block',
    fontSize: '1.6rem'
  }
}));

export default Footer;
